import type {
  ContextObjectTypes,
  PageConfigurationCondition,
  Workflow,
} from '@generated/graphql';
import type { TranslatedString } from '@interfaces/shared';

export enum PageObjectType {
  INDIVIDUAL = 'INDIVIDUAL',
  NON_INDIVIDUAL = 'NON_INDIVIDUAL',
  GOAL = 'GOAL',
  ACCOUNT = 'ACCOUNT',
  SUB_ACCOUNT = 'SUB_ACCOUNT',
  HOUSEHOLD = 'HOUSEHOLD',
  ACCOUNT_GROUP = 'ACCOUNT_GROUP',
}

type ClientPageOptions = {
  maxPageWidth?: number;
  enableContent?: boolean;
  showUpcomingMaintenanceSchedule?: boolean;
  [key: string]: unknown;
};

export type TabWorkflow = Pick<Workflow, 'id'> &
  Partial<Pick<Workflow, 'state' | 'objectType'>>;

export type TabInterface = {
  label: TranslatedString;
  /** Material icon name, or empty / omitted for no tab icon. */
  icon?: string | null;
  widgets: WidgetInterface[];
  translatedUrl?: TranslatedString;
  condition?: PageConfigurationCondition;
  id?: string;
  isHidden?: boolean;
  contextObject?: ContextObjectTypes;
  workflow?: TabWorkflow;
};

export type ClientPageInterface = {
  name: string;
  type: PageObjectType;
  tabs: TabInterface[];
  options?: ClientPageOptions;
};

export type WidgetInterface = {
  type: string;
  // biome-ignore lint/suspicious/noExplicitAny: widget options are heterogeneous JSON from page configuration
  options: any;
  // Server-computed, read-only enrichment; not an admin-editable widget field.
  constraints?: Record<string, unknown>;
  condition?: PageConfigurationCondition;
  contextObject?: ContextObjectTypes;
  id?: string;
  isHidden?: boolean;
};
